export default "__VITE_ASSET__DsNCuyLQ__"